CustomTC.define('modules/transcriptions/transcriptions',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/language', 'text!modules/transcriptions/htmls/transcriptions.html', 'css!modules/transcriptions/css/transcriptions'], function(util, core, config, constants, options, language, transcriptions) {
    return {
        transcript: '',
        subtitles: '',
        transcriptionEnabled: 1,
        transcriptionsInited: false,
        init: function(playerUI, subtitles) {
            if (options.disableTranscription === true) {
                this.transcriptionEnabled = false;
            }
            this.playerUI = playerUI;
            if (!this.transcriptionsInited) {
                core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(transcriptions);
            }
            this.transcriptionsInited = true;
            this.loadTranscriptions(subtitles);
        },
        loadTranscriptions: function(subtitles) {
            var self = this;
            self.subtitles = subtitles;
            for (i in subtitles) {
                if (options.getDefaultSubtitle() === '') {
                    if (i === 0) {
                        var jSONURL = subtitles[i]['json'];
                        core.getJSON(jSONURL, function(data) {
                            self.transcript = data.transcripts;
                        });
                        break
                    }
                } else {
                    if (subtitles[i]['type'] === options.getDefaultSubtitle()) {
                        var jSONURL = subtitles[i]['json'];
                        core.getJSON(jSONURL, function(data) {
                            self.transcript = data.transcripts;
                        });
                        break
                    }
                }
            }
        },
        changeTranscriptions: function(type, player) {
            var self = this;
            var subtitles = self.subtitles;
            for (i in subtitles) {
                if (subtitles[i]['type'] === type) {
                    var jSONURL = subtitles[i]['json'];
                    core.getJSON(jSONURL, function(data) {
                        self.transcript = data.transcripts;
                        player.resetTranscriptions();
                    });
                    break;
                }
            }
        }
    };
});
